module.exports = __webpack_public_path__ + "02_short_grey.c632890a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_short_grey.png
// module id = CYTr
// module chunks = 0